export default __webpack_public_path__ + "static/media/bewerber-first-img.1331abdd.png";